import * as React from "react";
import {connect} from "react-redux";
import {none, option, Option} from "ts-option";
import {Dispatch} from "redux";
import Job from "../../../model/job/Job";
import {editJob} from "../../../store/action/job/job";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import TypeDropdown from "../../lead/v4/leadType/TypeDropdown";
import Toast from "../../helper/Toast";
import {RootState} from "../../../store/reducer/root/RootState";
import {isDefined, notifyBugsnagAndShowToast} from "../../../utils/Utils";
import Merchant from "../../../model/merchant/Merchant";

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface ReduxProps {
	/**
	 * Merchants.
	 */
	merchants: Merchant[],
	/**
	 * Indicates if edition is disabled
	 */
	disabled: boolean
}

interface DispatchProps {
	/**
	 * Edit job action.
	 * @param {Job} job
	 */
	editJob: (job: Job) => void;
}

type Props = ComponentProps & ReduxProps & DispatchProps

class JobMerchantDropdown extends React.PureComponent<Props> {

	render() {
		const selectedMerchantId = this.props.job.flatMap(j => j.data.merchantId).orNull;
		return (
			<TypeDropdown selectedTypeId={selectedMerchantId}
						  onSelect={this.onSelect}
						  types={this.props.merchants}
						  title={"MERCHANT"}
						  placeholder={"Select merchant"}
						  clearable
						  onClearClick={this.onClearClick}
						  disabled={this.props.disabled}/>
		);
	}

	onSelect = (merchant: DictionaryItem) => {
		this.props.job.map(j => {
			const updatedJob = j.copy(
				{data: j.data.copy({merchantId: option(merchant.id), merchantBranchLocationId: none})});
			this.props.editJob(updatedJob);
		})
	};

	onClearClick = () => {
		this.props.job.map(j => {
			const updatedJob = j.copy({data: j.data.copy({merchantId: none, merchantBranchLocationId: none})});
			this.props.editJob(updatedJob);
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editJob: (job: Job) => dispatch(
			editJob(
				job,
				() => Toast.success("Merchant updated", "Job details update"),
				(err) => notifyBugsnagAndShowToast(err, "Job details update"))
		)
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const jobId = props.job.map(j => j.id).orNull
	const jobType = props.job.flatMap(
		j => option(state.jobType.jobTypes.getOrElse([]).filter(jt => jt.id == j.data.jobTypeId)[0]))
	const disabled = isDefined(state.billOfMaterials.bomMap[jobId]) || jobType.map(jt => jt.repairWithParts).orNull
	return {
		merchants: state.merchant.merchants.getOrElse([]),
		disabled
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobMerchantDropdown)